import React from 'react';
import { Dropdown } from 'semantic-ui-react'

const prepareCompanySelection = (user) => {
    const { uuid, name, companies } = user;
    const companyOptions = [];
    for (let i = 0; i < companies.length; i++) {
        companyOptions.push({ text: companies[i].companyName, value: companies[i].companyId });
    }
    return companyOptions;
}

const EcardCompanyFilter = (props) => {
    const companyOptions = prepareCompanySelection(props.user);
    return (
        <Dropdown
            placeholder='Select Company'
            fluid
            selection
            options={companyOptions}
            value={props.selectedCompany}
            onChange={(e, { value}) => props.updateCompanySelected(value)}
        />
    );
}

export default EcardCompanyFilter;
